export const FORM_QUESTION_ANSWERED = 'FORM_QUESTION_ANSWERED';
export const PREQUAL_QUESTION_ANSWERED = 'PREQUAL_QUESTION_ANSWERED';

function answeredQuestion({ id, answer, mode, isForm, name }) {
  return {
    type: isForm ? FORM_QUESTION_ANSWERED : PREQUAL_QUESTION_ANSWERED,
    id,
    isAnswered: true,
    hasError: false,
    answer,
    mode,
    name
  };
}

export function questionAnswered(question) {
  return dispatch => dispatch(answeredQuestion(question));
}
